<template>
  <input class="input" type="tel" :value="initialValue" :placeholder="placeholder" name="cpf_cnpj"/>
</template>

<script>
  export default {
    props: ['value', 'placeholder'],
    watch: {
      value: function (value) {
        this.initialValue = value;
      }
    },
    data() {
      return {
        initialValue: ''
      }
    },
    created() {
      this.initialValue = this.value;
    },
    mounted() {
      let that = this;
      let input = $(this.$el);

      input.on('change', function (e) {
        let value = e.target.value;
        that.$emit('input', value);
      });

      let options = {
        onKeyPress: function (cpf, ev, el, op) {
          let masks = ['000.000.000-000', '00.000.000/0000-00'],
              mask = (cpf.length > 14) ? masks[1] : masks[0];
          el.mask(mask, op);
        }
      };

      input.mask('000.000.000-000', options);

    },
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/utils/InputMaskCpfCnpj.vue